<template>
  <div>
    <Container :class="$style.container">
      <Form>
        <FormCard>
          <FormHeading>
            {{ steps.DONATION_WAY }}
          </FormHeading>

          <FormRow>
            <div style="display: flex; justify-content: space-between;">
              <ChosenButton
                :chosen="donationPeriod === donationPeriodType.DONATION_PERIOD"
                @click.native="chose(donationPeriodType.DONATION_PERIOD)"
              >
                {{ donationPeriodType.DONATION_PERIOD }}
              </ChosenButton>
              <ChosenButton
                :chosen="donationPeriod === donationPeriodType.DONATION_SINGLE"
                @click.native="chose(donationPeriodType.DONATION_SINGLE)"
              >
                {{ donationPeriodType.DONATION_SINGLE }}
              </ChosenButton>
            </div>
          </FormRow>
          <FormRow>
            <a
              :class="$style.other"
              @click="openOverlay('OtherDonationWay')"
            >
              查看其他捐款方式
            </a>
          </FormRow>
          <br>
          <Align right>
            <Button
              :small="!isTabletLandscapeUp"
              @click.native="submit()"
            >
              下一步
            </Button>
          </Align>
        </FormCard>
        <p :class="$style.text">
          如有任何問題，歡迎寄信至 fin@teach4taiwan.org 詢問
        </p>
      </Form>
    </Container>

    <transition
      name="fade"
      mode="out-in"
    >
      <Overlay
        :is-open="showOtherDonationWay"
        @close="closeOverlay('OtherDonationWay')"
      >
        <OverlayTitle>其他捐款方式</OverlayTitle>
        <OverlayItems>
          <OverlayItem
            question="臺幣轉帳"
            :answer="oneline(`
              <p>請依下列資訊進行轉帳，並於轉帳完將收據開立資訊（收據抬頭姓名、身分證字號或公司統編、聯絡電話、電子信箱）寄到 fin@teach4taiwan.org。</p>
              <ul>
                <li>戶名｜財團法人為台灣而教教育基金會</li>
                <li>匯款銀行｜國泰世華銀行忠孝分行 (013)</li>
                <li>匯款帳戶｜<code>011035009622</code></li>
              </ul>
            `)"
          />
          <OverlayItem
            question="非台幣轉帳"
            :answer="oneline(`
              <p>請用以下資訊進行轉帳：</p>
              <ul>
                <li>Beneficiary's Name｜TEACH FOR TAIWAN</li>
                <li>A/C with Bank｜CATHAY UNITED BANK, TAIPEI, TAIWAN（國泰世華商業銀行）</li>
                <li>A/C with Bank Address｜3F, NO. 65, GUAN CHIEN RD., TAIPEI, TAIWAN（台北市館前路 65 號 3 樓）</li>
                <li>Account No.｜<code>011087069003</code></li>
                <li>Swift Code｜<code>UWCBTWTP</code></li>
                <li>Beneficiary's Telephone No.｜<code>+886 (02)-2345-6225</code></li>
                <li>Email Address｜fin@teach4taiwan.org</li>
              </ul>
            `)"
          />
          <OverlayItem
            question="郵政劃撥"
            :answer="oneline(`
              <p>請至郵局索取劃撥單，並詳細填寫捐款人聯絡資料，完成劃撥。</p>
              <ul>
                <li>戶名｜財團法人為台灣而教教育基金會</li>
                <li>劃撥帳號｜<code>50394835</code></li>
              </ul>
            `)"
          />
          <OverlayItem
            question="支票匯款"
            :answer="oneline(`
              <p>請將支票寄送到 TFT 辦公室，並請於背面註明禁止背書轉讓。</p>
              <ul>
                <li>受款人｜財團法人為台灣而教教育基金會</li>
                <li>支票寄送地址｜10043 台北市中正區寶慶路 25 號 2 樓 TFT 財務組收</li>
              </ul>
            `)"
          />
          <OverlayItem
            question="美金捐款"
            :answer="oneline(`
              <p>透過「世台聯合基金會(STUF UnitedFundInc.)」捐款。世台為在美國登記成立之非營利慈善機構，為美國聯邦政府核可之 501(c)(3) 組織。由世台基金會開立的捐贈收據，在美國可依法扣抵聯邦所得稅。</p>
              <hr>
              <div>【支票】</div>
              <p>請列印填寫 <a href='https://drive.google.com/file/d/1UmJCSACEzdHKjvlmjMy11a7GH7hzF45w/view?usp=sharing' target='_blank' rel='noopener'>「Pledge Form」</a>，完成填寫此表後，連同支票寄給「世台聯合基金會」。</p>
              <ul>
                <li>支票抬頭｜STUF United Fund Inc.</li>
                <li>支票備註｜支票中須備註指名捐贈 Donor-designated fund - Teach For Taiwan</li>
                <li>郵寄地址｜STUF United Fund P.O. Box 520511 Flushing, NY 11352</li>
              </ul>
              <hr>
              <div>【匯款】</div>
              <p>捐款者若以匯款的方式捐贈，請先行聯繫世台基金會 黃怡妙 總幹事，世台基金會將提供詳細匯款資訊給您。捐款時請指名捐贈「Donor-designated fund - Teach For Taiwan」。</p>
              <p>黃總幹事（Yi-Miao Huang）聯絡資訊：</p>
              <ul>
                <li>Tel: <code>914-433-0415</code></li>
                <li>Email: yimiao@stufunited.org</li>
              </ul>
            `)"
          />
        </OverlayItems>
      </Overlay>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { mapFields } from 'vuex-map-fields';
// configs
import steps from '@/configs/steps';
import donationPeriodType from '@/configs/donationPeriod';

import {
  saveStore,
  clear as clearStorage,
} from '@/lib/storage';

import { oneline } from '@/helpers/common';

import Container from '../../components/layout/Container';
import Align from '../../components/layout/Align';

import Overlay from '../../components/overlay/Overlay';
import OverlayItem from '../../components/overlay/OverlayItem';
import OverlayItems from '../../components/overlay/OverlayItems';
import OverlayTitle from '../../components/overlay/OverlayTitle';

import Form from '../../components/form/Form';
import FormRow from '../../components/form/FormRow';
import FormCard from '../../components/form/FormCard';
import FormHeading from '../../components/form/FormHeading';

import Button from '../../components/buttons/Button';
import ChosenButton from '../../components/buttons/ChosenButton';

export default {
  components: {
    Container,
    Align,

    Overlay,
    OverlayItem,
    OverlayItems,
    OverlayTitle,

    Form,
    FormCard,
    FormHeading,
    FormRow,

    ChosenButton,
    Button,
  },
  data() {
    return {
      steps: Object.freeze(steps),
      donationPeriodType: Object.freeze(donationPeriodType),
    };
  },
  computed: {
    ...mapState({
      showOtherDonationWay: state => state.overlay.showOtherDonationWay,
    }),

    ...mapFields('donation', [
      'donationPeriod',
    ]),

    ...mapGetters('ui', [
      'isTabletLandscapeUp',
    ]),

  },

  methods: {
    oneline,
    ...mapMutations({
      openOverlay: 'overlay/open',
      closeOverlay: 'overlay/close',
      updateStep: 'breadCrumb/updateStep',
      resetFields: 'donation/resetFields',
    }),

    submit() {
      saveStore();
      this.$router.push({ name: this.donationPeriod === donationPeriodType.DONATION_SINGLE ? 'single-amount' : 'period-amount' });
    },

    chose(data) {
      clearStorage();
      this.resetFields();
      this.donationPeriod = data;
    },
  },
};

</script>

<style lang="scss" module>
.container {
  margin: 40px auto;
}

.other {
  cursor: pointer;
  font-size: 1.4rem;
  color: #e73273;
  margin: 10px auto;
}

.text {
  font-size: 1.4rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: 0.8px;
  color: $color-text;
  margin: 10px auto 10px;
}
</style>
